import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppQuery } from "../../../api/fetchClient";
import { QUERY_KEYS } from "../../../api/queryKeys";
import { GET_POST } from "../../../api/url";
import { arrowBack, arrowForward, ProfileImage } from "../../../assets/image";
import moment from "moment/moment";
import Loader from "../../../components/common/Loader";

const Posts = ({ posts }) => {
  const [page, setPage] = useState(1);

  const { data, isLoading } = useAppQuery({
    queryKey: [QUERY_KEYS.POSTS, page],
    url: `${GET_POST}all?page=${page}`,
  });

  const navigate = useNavigate();
  const handlePost = (post) => {
    navigate("/admin/post/postDetails", { state: { postId: post._id } });
  };

  const handleUserProfile = (user) => {
    navigate("/admin/user/userDetails", { state: { userId: user._id } });
  };

  const { pagination } = data?.results ?? {};
  const { currentPage, totalPages } = pagination ?? {};

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <div className="sm:flex sm:items-center">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-primary">Posts</h1>
          <p className="mt-2 text-sm text-gray-700 capitalize">Detailed Feed of Uploaded Posts and Captions</p>
        </div>
      </div>
      <div className="overflow-x-auto">
        {data?.results?.data && data.results.data.length > 0 ? (
          <table className="min-w-full bg-white border border-gray-200 rounded-xl shadow-md">
            <thead>
              <tr className="bg-gray-100 text-left text-base font-semibold text-gray-700">
                <th className="px-6 py-3">Post Image</th>
                <th className="px-6 py-3">Posted By</th>
                <th className="px-6 py-3">Caption</th>
                <th className="px-6 py-3 text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              {data.results.data.map((post) => (
                <tr key={post?._id} className="hover:bg-gray-50 border-b">
                  <td className="px-6 py-4">
                    {post.postImages.length > 0 ? (
                      <img
                        src={post.postImages[0]}
                        alt="Post"
                        className="w-14 h-14 object-cover rounded-lg"
                        onClick={() => handlePost(post)}
                      />
                    ) : (
                      <span className="text-gray-400 italic">No Image</span>
                    )}
                  </td>
                  <td onClick={() => handleUserProfile(post.user)} className="px-6 py-4 flex items-center gap-3">
                    {post?.user?.profileImage ? (
                      <img
                        src={post.user.profileImage}
                        alt="User"
                        className="w-10 h-10 rounded-full object-cover"
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = ProfileImage; // fallback image
                        }}
                      />
                    ) : (
                      <div className="w-12 h-12 rounded-full overflow-hidden">
                        <img src={ProfileImage} alt="Default User" className="w-full h-full object-cover" />
                      </div>
                    )}

                    <div className="grid gap-1">
                      <p className="font-semibold text-gray-800">{post?.user?.userName}</p>
                      <p>{moment(post?.createdAt).fromNow()}</p>
                    </div>
                  </td>
                  <td className="relative max-w-[200px] group">
                    <div className="line-clamp-2 cursor-pointer">
                      {post?.caption ? post.caption : <span className="text-gray-400 italic">No Caption Found</span>}
                    </div>
                  </td>

                  <td className="px-6 py-4 text-right">
                    <button
                      onClick={() => handlePost(post)}
                      className="bg-primary text-white text-sm font-medium py-1.5 px-4 rounded-md hover:bg-blue-600 transition-colors"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-center text-gray-500 py-10 text-lg">No posts available.</div>
        )}
      </div>
      {totalPages > 1 && (
        <div className="mt-6 flex justify-center items-center space-x-2">
          <button
            onClick={() => setPage((old) => Math.max(old - 1, 1))}
            disabled={page === 1}
            className={`flex items-center px-2 sm:px-3 py-2 rounded-md border text-sm font-medium ${
              page === 1
                ? "bg-gray-200 text-light cursor-not-allowed"
                : "bg-white text-gray-700 hover:bg-gray-100 border-gray-300"
            }`}
          >
            <img src={arrowBack} alt="" />
          </button>

          {Array.from({ length: totalPages }, (_, index) =>
            index < 2 || index > totalPages - 3 || Math.abs(page - (index + 1)) <= 1 ? (
              <button
                key={index}
                onClick={() => setPage(index + 1)}
                className={`px-3 sm:px-4 py-2 rounded-md border text-sm font-medium ${
                  currentPage === index + 1
                    ? "bg-primary text-white border-primary"
                    : "bg-white text-gray-700 hover:bg-gray-100 border-gray-300"
                }`}
              >
                {index + 1}
              </button>
            ) : null
          )}

          <button
            onClick={() => setPage((old) => old + 1)}
            disabled={page === totalPages}
            className={`flex items-center px-2 sm:px-3 py-2 rounded-md border text-sm font-medium ${
              page === totalPages
                ? "bg-gray-200 text-light cursor-not-allowed"
                : "bg-white text-gray-700 hover:bg-gray-100 border-gray-300"
            }`}
          >
            <img src={arrowForward} alt="" />
          </button>
        </div>
      )}
    </div>
  );
};

export default Posts;
